import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
  useRentPriceTypeCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const tenantIndustrialPlotRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    plotArea: validationRules.plotArea,
    separableSpace: validationRules.separableSpace,
    usageType: validationRules.usageType,
    price: useRentPriceTypeCondition,
  },
  description: defaultDescription,
  otherFacilities: {
    gfz: validationRules.gfzField,
    grz: validationRules.grzField,
  },
  contactInfo: defaultContactInfo,
}
